/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedClientRouteImport } from './routes/_authenticated/$client'
import { Route as ShareTokenRouteImport } from './routes/share/$token'
import { Route as AuthenticatedClientIndexRouteImport } from './routes/_authenticated/$client/index'
import { Route as AuthenticatedClientDomainRouteImport } from './routes/_authenticated/$client/$domain'
import { Route as AuthenticatedChecksIndexRouteImport } from './routes/_authenticated/checks/index'
import { Route as AuthenticatedChecksRunRouteImport } from './routes/_authenticated/checks/$run'
import { Route as AuthenticatedKnowledgeIndexRouteImport } from './routes/_authenticated/knowledge/index'
import { Route as AuthenticatedKnowledgeNoteRouteImport } from './routes/_authenticated/knowledge/$note'
import { Route as AuthenticatedClientDomainIndexRouteImport } from './routes/_authenticated/$client/$domain/index'
import { Route as AuthenticatedClientDomainSlugRouteImport } from './routes/_authenticated/$client/$domain/$slug'
import { Route as AuthenticatedClientDomainSlugIndexRouteImport } from './routes/_authenticated/$client/$domain/$slug/index'
import { Route as AuthenticatedClientDomainSlugWorkRouteImport } from './routes/_authenticated/$client/$domain/$slug/work'
import { Route as AuthenticatedClientDomainSlugFeedbackIndexRouteImport } from './routes/_authenticated/$client/$domain/$slug/feedback/index'
import { Route as AuthenticatedClientDomainSlugJournalIndexRouteImport } from './routes/_authenticated/$client/$domain/$slug/journal/index'
import { Route as AuthenticatedClientDomainSlugJournalEntryRouteImport } from './routes/_authenticated/$client/$domain/$slug/journal/$entry'
import { Route as AuthenticatedClientDomainSlugLogsIndexRouteImport } from './routes/_authenticated/$client/$domain/$slug/logs/index'
import { Route as AuthenticatedClientDomainSlugLogsLogRouteImport } from './routes/_authenticated/$client/$domain/$slug/logs/$log'
import { Route as AuthenticatedClientDomainSlugPlansIndexRouteImport } from './routes/_authenticated/$client/$domain/$slug/plans/index'
import { Route as AuthenticatedClientDomainSlugPlansPlanRouteImport } from './routes/_authenticated/$client/$domain/$slug/plans/$plan'
import { Route as AuthenticatedClientDomainSlugTicketsIndexRouteImport } from './routes/_authenticated/$client/$domain/$slug/tickets/index'
import { Route as AuthenticatedClientDomainSlugTicketsTicketRouteImport } from './routes/_authenticated/$client/$domain/$slug/tickets/$ticket'
import { Route as AuthenticatedClientDomainSlugInterviewTicketRouteImport } from './routes/_authenticated/$client/$domain/$slug_.interview.$ticket'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientRoute = AuthenticatedClientRouteImport.update({
  id: '/$client',
  path: '/$client',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedClientIndexRoute =
  AuthenticatedClientIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedClientRoute,
  } as any)
const AuthenticatedClientDomainRoute =
  AuthenticatedClientDomainRouteImport.update({
    id: '/$domain',
    path: '/$domain',
    getParentRoute: () => AuthenticatedClientRoute,
  } as any)
const AuthenticatedChecksIndexRoute =
  AuthenticatedChecksIndexRouteImport.update({
    id: '/checks/',
    path: '/checks/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChecksRunRoute = AuthenticatedChecksRunRouteImport.update({
  id: '/checks/$run',
  path: '/checks/$run',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedKnowledgeIndexRoute =
  AuthenticatedKnowledgeIndexRouteImport.update({
    id: '/knowledge/',
    path: '/knowledge/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeNoteRoute =
  AuthenticatedKnowledgeNoteRouteImport.update({
    id: '/knowledge/$note',
    path: '/knowledge/$note',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientDomainIndexRoute =
  AuthenticatedClientDomainIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedClientDomainRoute,
  } as any)
const AuthenticatedClientDomainSlugRoute =
  AuthenticatedClientDomainSlugRouteImport.update({
    id: '/$slug',
    path: '/$slug',
    getParentRoute: () => AuthenticatedClientDomainRoute,
  } as any)
const AuthenticatedClientDomainSlugIndexRoute =
  AuthenticatedClientDomainSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugWorkRoute =
  AuthenticatedClientDomainSlugWorkRouteImport.update({
    id: '/work',
    path: '/work',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugFeedbackIndexRoute =
  AuthenticatedClientDomainSlugFeedbackIndexRouteImport.update({
    id: '/feedback/',
    path: '/feedback/',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugJournalIndexRoute =
  AuthenticatedClientDomainSlugJournalIndexRouteImport.update({
    id: '/journal/',
    path: '/journal/',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugJournalEntryRoute =
  AuthenticatedClientDomainSlugJournalEntryRouteImport.update({
    id: '/journal/$entry',
    path: '/journal/$entry',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugLogsIndexRoute =
  AuthenticatedClientDomainSlugLogsIndexRouteImport.update({
    id: '/logs/',
    path: '/logs/',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugLogsLogRoute =
  AuthenticatedClientDomainSlugLogsLogRouteImport.update({
    id: '/logs/$log',
    path: '/logs/$log',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugPlansIndexRoute =
  AuthenticatedClientDomainSlugPlansIndexRouteImport.update({
    id: '/plans/',
    path: '/plans/',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugPlansPlanRoute =
  AuthenticatedClientDomainSlugPlansPlanRouteImport.update({
    id: '/plans/$plan',
    path: '/plans/$plan',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugTicketsIndexRoute =
  AuthenticatedClientDomainSlugTicketsIndexRouteImport.update({
    id: '/tickets/',
    path: '/tickets/',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugTicketsTicketRoute =
  AuthenticatedClientDomainSlugTicketsTicketRouteImport.update({
    id: '/tickets/$ticket',
    path: '/tickets/$ticket',
    getParentRoute: () => AuthenticatedClientDomainSlugRoute,
  } as any)
const AuthenticatedClientDomainSlugInterviewTicketRoute =
  AuthenticatedClientDomainSlugInterviewTicketRouteImport.update({
    id: '/$slug_/interview/$ticket',
    path: '/$slug/interview/$ticket',
    getParentRoute: () => AuthenticatedClientDomainRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/$client': typeof AuthenticatedClientRouteWithChildren
  '/share/$token': typeof ShareTokenRoute
  '/$client/$domain': typeof AuthenticatedClientDomainRouteWithChildren
  '/checks/$run': typeof AuthenticatedChecksRunRoute
  '/knowledge/$note': typeof AuthenticatedKnowledgeNoteRoute
  '/$client/': typeof AuthenticatedClientIndexRoute
  '/checks/': typeof AuthenticatedChecksIndexRoute
  '/knowledge/': typeof AuthenticatedKnowledgeIndexRoute
  '/$client/$domain/$slug': typeof AuthenticatedClientDomainSlugRouteWithChildren
  '/$client/$domain/': typeof AuthenticatedClientDomainIndexRoute
  '/$client/$domain/$slug/work': typeof AuthenticatedClientDomainSlugWorkRoute
  '/$client/$domain/$slug/': typeof AuthenticatedClientDomainSlugIndexRoute
  '/$client/$domain/$slug/journal/$entry': typeof AuthenticatedClientDomainSlugJournalEntryRoute
  '/$client/$domain/$slug/logs/$log': typeof AuthenticatedClientDomainSlugLogsLogRoute
  '/$client/$domain/$slug/plans/$plan': typeof AuthenticatedClientDomainSlugPlansPlanRoute
  '/$client/$domain/$slug/tickets/$ticket': typeof AuthenticatedClientDomainSlugTicketsTicketRoute
  '/$client/$domain/$slug/interview/$ticket': typeof AuthenticatedClientDomainSlugInterviewTicketRoute
  '/$client/$domain/$slug/feedback/': typeof AuthenticatedClientDomainSlugFeedbackIndexRoute
  '/$client/$domain/$slug/journal/': typeof AuthenticatedClientDomainSlugJournalIndexRoute
  '/$client/$domain/$slug/logs/': typeof AuthenticatedClientDomainSlugLogsIndexRoute
  '/$client/$domain/$slug/plans/': typeof AuthenticatedClientDomainSlugPlansIndexRoute
  '/$client/$domain/$slug/tickets/': typeof AuthenticatedClientDomainSlugTicketsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/share/$token': typeof ShareTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/checks/$run': typeof AuthenticatedChecksRunRoute
  '/knowledge/$note': typeof AuthenticatedKnowledgeNoteRoute
  '/$client': typeof AuthenticatedClientIndexRoute
  '/checks': typeof AuthenticatedChecksIndexRoute
  '/knowledge': typeof AuthenticatedKnowledgeIndexRoute
  '/$client/$domain': typeof AuthenticatedClientDomainIndexRoute
  '/$client/$domain/$slug/work': typeof AuthenticatedClientDomainSlugWorkRoute
  '/$client/$domain/$slug': typeof AuthenticatedClientDomainSlugIndexRoute
  '/$client/$domain/$slug/journal/$entry': typeof AuthenticatedClientDomainSlugJournalEntryRoute
  '/$client/$domain/$slug/logs/$log': typeof AuthenticatedClientDomainSlugLogsLogRoute
  '/$client/$domain/$slug/plans/$plan': typeof AuthenticatedClientDomainSlugPlansPlanRoute
  '/$client/$domain/$slug/tickets/$ticket': typeof AuthenticatedClientDomainSlugTicketsTicketRoute
  '/$client/$domain/$slug/interview/$ticket': typeof AuthenticatedClientDomainSlugInterviewTicketRoute
  '/$client/$domain/$slug/feedback': typeof AuthenticatedClientDomainSlugFeedbackIndexRoute
  '/$client/$domain/$slug/journal': typeof AuthenticatedClientDomainSlugJournalIndexRoute
  '/$client/$domain/$slug/logs': typeof AuthenticatedClientDomainSlugLogsIndexRoute
  '/$client/$domain/$slug/plans': typeof AuthenticatedClientDomainSlugPlansIndexRoute
  '/$client/$domain/$slug/tickets': typeof AuthenticatedClientDomainSlugTicketsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/$client': typeof AuthenticatedClientRouteWithChildren
  '/share/$token': typeof ShareTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$client/$domain': typeof AuthenticatedClientDomainRouteWithChildren
  '/_authenticated/checks/$run': typeof AuthenticatedChecksRunRoute
  '/_authenticated/knowledge/$note': typeof AuthenticatedKnowledgeNoteRoute
  '/_authenticated/$client/': typeof AuthenticatedClientIndexRoute
  '/_authenticated/checks/': typeof AuthenticatedChecksIndexRoute
  '/_authenticated/knowledge/': typeof AuthenticatedKnowledgeIndexRoute
  '/_authenticated/$client/$domain/$slug': typeof AuthenticatedClientDomainSlugRouteWithChildren
  '/_authenticated/$client/$domain/': typeof AuthenticatedClientDomainIndexRoute
  '/_authenticated/$client/$domain/$slug/work': typeof AuthenticatedClientDomainSlugWorkRoute
  '/_authenticated/$client/$domain/$slug/': typeof AuthenticatedClientDomainSlugIndexRoute
  '/_authenticated/$client/$domain/$slug/journal/$entry': typeof AuthenticatedClientDomainSlugJournalEntryRoute
  '/_authenticated/$client/$domain/$slug/logs/$log': typeof AuthenticatedClientDomainSlugLogsLogRoute
  '/_authenticated/$client/$domain/$slug/plans/$plan': typeof AuthenticatedClientDomainSlugPlansPlanRoute
  '/_authenticated/$client/$domain/$slug/tickets/$ticket': typeof AuthenticatedClientDomainSlugTicketsTicketRoute
  '/_authenticated/$client/$domain/$slug_/interview/$ticket': typeof AuthenticatedClientDomainSlugInterviewTicketRoute
  '/_authenticated/$client/$domain/$slug/feedback/': typeof AuthenticatedClientDomainSlugFeedbackIndexRoute
  '/_authenticated/$client/$domain/$slug/journal/': typeof AuthenticatedClientDomainSlugJournalIndexRoute
  '/_authenticated/$client/$domain/$slug/logs/': typeof AuthenticatedClientDomainSlugLogsIndexRoute
  '/_authenticated/$client/$domain/$slug/plans/': typeof AuthenticatedClientDomainSlugPlansIndexRoute
  '/_authenticated/$client/$domain/$slug/tickets/': typeof AuthenticatedClientDomainSlugTicketsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/$client'
    | '/share/$token'
    | '/$client/$domain'
    | '/checks/$run'
    | '/knowledge/$note'
    | '/$client/'
    | '/checks/'
    | '/knowledge/'
    | '/$client/$domain/$slug'
    | '/$client/$domain/'
    | '/$client/$domain/$slug/work'
    | '/$client/$domain/$slug/'
    | '/$client/$domain/$slug/journal/$entry'
    | '/$client/$domain/$slug/logs/$log'
    | '/$client/$domain/$slug/plans/$plan'
    | '/$client/$domain/$slug/tickets/$ticket'
    | '/$client/$domain/$slug/interview/$ticket'
    | '/$client/$domain/$slug/feedback/'
    | '/$client/$domain/$slug/journal/'
    | '/$client/$domain/$slug/logs/'
    | '/$client/$domain/$slug/plans/'
    | '/$client/$domain/$slug/tickets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/share/$token'
    | '/'
    | '/checks/$run'
    | '/knowledge/$note'
    | '/$client'
    | '/checks'
    | '/knowledge'
    | '/$client/$domain'
    | '/$client/$domain/$slug/work'
    | '/$client/$domain/$slug'
    | '/$client/$domain/$slug/journal/$entry'
    | '/$client/$domain/$slug/logs/$log'
    | '/$client/$domain/$slug/plans/$plan'
    | '/$client/$domain/$slug/tickets/$ticket'
    | '/$client/$domain/$slug/interview/$ticket'
    | '/$client/$domain/$slug/feedback'
    | '/$client/$domain/$slug/journal'
    | '/$client/$domain/$slug/logs'
    | '/$client/$domain/$slug/plans'
    | '/$client/$domain/$slug/tickets'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/$client'
    | '/share/$token'
    | '/_authenticated/'
    | '/_authenticated/$client/$domain'
    | '/_authenticated/checks/$run'
    | '/_authenticated/knowledge/$note'
    | '/_authenticated/$client/'
    | '/_authenticated/checks/'
    | '/_authenticated/knowledge/'
    | '/_authenticated/$client/$domain/$slug'
    | '/_authenticated/$client/$domain/'
    | '/_authenticated/$client/$domain/$slug/work'
    | '/_authenticated/$client/$domain/$slug/'
    | '/_authenticated/$client/$domain/$slug/journal/$entry'
    | '/_authenticated/$client/$domain/$slug/logs/$log'
    | '/_authenticated/$client/$domain/$slug/plans/$plan'
    | '/_authenticated/$client/$domain/$slug/tickets/$ticket'
    | '/_authenticated/$client/$domain/$slug_/interview/$ticket'
    | '/_authenticated/$client/$domain/$slug/feedback/'
    | '/_authenticated/$client/$domain/$slug/journal/'
    | '/_authenticated/$client/$domain/$slug/logs/'
    | '/_authenticated/$client/$domain/$slug/plans/'
    | '/_authenticated/$client/$domain/$slug/tickets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  ShareTokenRoute: typeof ShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$client': {
      id: '/_authenticated/$client'
      path: '/$client'
      fullPath: '/$client'
      preLoaderRoute: typeof AuthenticatedClientRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$client/': {
      id: '/_authenticated/$client/'
      path: '/'
      fullPath: '/$client/'
      preLoaderRoute: typeof AuthenticatedClientIndexRouteImport
      parentRoute: typeof AuthenticatedClientRoute
    }
    '/_authenticated/$client/$domain': {
      id: '/_authenticated/$client/$domain'
      path: '/$domain'
      fullPath: '/$client/$domain'
      preLoaderRoute: typeof AuthenticatedClientDomainRouteImport
      parentRoute: typeof AuthenticatedClientRoute
    }
    '/_authenticated/checks/': {
      id: '/_authenticated/checks/'
      path: '/checks'
      fullPath: '/checks/'
      preLoaderRoute: typeof AuthenticatedChecksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/checks/$run': {
      id: '/_authenticated/checks/$run'
      path: '/checks/$run'
      fullPath: '/checks/$run'
      preLoaderRoute: typeof AuthenticatedChecksRunRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge/': {
      id: '/_authenticated/knowledge/'
      path: '/knowledge'
      fullPath: '/knowledge/'
      preLoaderRoute: typeof AuthenticatedKnowledgeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge/$note': {
      id: '/_authenticated/knowledge/$note'
      path: '/knowledge/$note'
      fullPath: '/knowledge/$note'
      preLoaderRoute: typeof AuthenticatedKnowledgeNoteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$client/$domain/': {
      id: '/_authenticated/$client/$domain/'
      path: '/'
      fullPath: '/$client/$domain/'
      preLoaderRoute: typeof AuthenticatedClientDomainIndexRouteImport
      parentRoute: typeof AuthenticatedClientDomainRoute
    }
    '/_authenticated/$client/$domain/$slug': {
      id: '/_authenticated/$client/$domain/$slug'
      path: '/$slug'
      fullPath: '/$client/$domain/$slug'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugRouteImport
      parentRoute: typeof AuthenticatedClientDomainRoute
    }
    '/_authenticated/$client/$domain/$slug/': {
      id: '/_authenticated/$client/$domain/$slug/'
      path: '/'
      fullPath: '/$client/$domain/$slug/'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugIndexRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug/work': {
      id: '/_authenticated/$client/$domain/$slug/work'
      path: '/work'
      fullPath: '/$client/$domain/$slug/work'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugWorkRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug/feedback/': {
      id: '/_authenticated/$client/$domain/$slug/feedback/'
      path: '/feedback'
      fullPath: '/$client/$domain/$slug/feedback/'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugFeedbackIndexRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug/journal/': {
      id: '/_authenticated/$client/$domain/$slug/journal/'
      path: '/journal'
      fullPath: '/$client/$domain/$slug/journal/'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugJournalIndexRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug/journal/$entry': {
      id: '/_authenticated/$client/$domain/$slug/journal/$entry'
      path: '/journal/$entry'
      fullPath: '/$client/$domain/$slug/journal/$entry'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugJournalEntryRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug/logs/': {
      id: '/_authenticated/$client/$domain/$slug/logs/'
      path: '/logs'
      fullPath: '/$client/$domain/$slug/logs/'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugLogsIndexRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug/logs/$log': {
      id: '/_authenticated/$client/$domain/$slug/logs/$log'
      path: '/logs/$log'
      fullPath: '/$client/$domain/$slug/logs/$log'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugLogsLogRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug/plans/': {
      id: '/_authenticated/$client/$domain/$slug/plans/'
      path: '/plans'
      fullPath: '/$client/$domain/$slug/plans/'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugPlansIndexRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug/plans/$plan': {
      id: '/_authenticated/$client/$domain/$slug/plans/$plan'
      path: '/plans/$plan'
      fullPath: '/$client/$domain/$slug/plans/$plan'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugPlansPlanRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug/tickets/': {
      id: '/_authenticated/$client/$domain/$slug/tickets/'
      path: '/tickets'
      fullPath: '/$client/$domain/$slug/tickets/'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugTicketsIndexRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug/tickets/$ticket': {
      id: '/_authenticated/$client/$domain/$slug/tickets/$ticket'
      path: '/tickets/$ticket'
      fullPath: '/$client/$domain/$slug/tickets/$ticket'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugTicketsTicketRouteImport
      parentRoute: typeof AuthenticatedClientDomainSlugRoute
    }
    '/_authenticated/$client/$domain/$slug_/interview/$ticket': {
      id: '/_authenticated/$client/$domain/$slug_/interview/$ticket'
      path: '/$slug/interview/$ticket'
      fullPath: '/$client/$domain/$slug/interview/$ticket'
      preLoaderRoute: typeof AuthenticatedClientDomainSlugInterviewTicketRouteImport
      parentRoute: typeof AuthenticatedClientDomainRoute
    }
  }
}

interface AuthenticatedClientDomainSlugRouteChildren {
  AuthenticatedClientDomainSlugWorkRoute: typeof AuthenticatedClientDomainSlugWorkRoute
  AuthenticatedClientDomainSlugIndexRoute: typeof AuthenticatedClientDomainSlugIndexRoute
  AuthenticatedClientDomainSlugJournalEntryRoute: typeof AuthenticatedClientDomainSlugJournalEntryRoute
  AuthenticatedClientDomainSlugLogsLogRoute: typeof AuthenticatedClientDomainSlugLogsLogRoute
  AuthenticatedClientDomainSlugPlansPlanRoute: typeof AuthenticatedClientDomainSlugPlansPlanRoute
  AuthenticatedClientDomainSlugTicketsTicketRoute: typeof AuthenticatedClientDomainSlugTicketsTicketRoute
  AuthenticatedClientDomainSlugFeedbackIndexRoute: typeof AuthenticatedClientDomainSlugFeedbackIndexRoute
  AuthenticatedClientDomainSlugJournalIndexRoute: typeof AuthenticatedClientDomainSlugJournalIndexRoute
  AuthenticatedClientDomainSlugLogsIndexRoute: typeof AuthenticatedClientDomainSlugLogsIndexRoute
  AuthenticatedClientDomainSlugPlansIndexRoute: typeof AuthenticatedClientDomainSlugPlansIndexRoute
  AuthenticatedClientDomainSlugTicketsIndexRoute: typeof AuthenticatedClientDomainSlugTicketsIndexRoute
}

const AuthenticatedClientDomainSlugRouteChildren: AuthenticatedClientDomainSlugRouteChildren =
  {
    AuthenticatedClientDomainSlugWorkRoute:
      AuthenticatedClientDomainSlugWorkRoute,
    AuthenticatedClientDomainSlugIndexRoute:
      AuthenticatedClientDomainSlugIndexRoute,
    AuthenticatedClientDomainSlugJournalEntryRoute:
      AuthenticatedClientDomainSlugJournalEntryRoute,
    AuthenticatedClientDomainSlugLogsLogRoute:
      AuthenticatedClientDomainSlugLogsLogRoute,
    AuthenticatedClientDomainSlugPlansPlanRoute:
      AuthenticatedClientDomainSlugPlansPlanRoute,
    AuthenticatedClientDomainSlugTicketsTicketRoute:
      AuthenticatedClientDomainSlugTicketsTicketRoute,
    AuthenticatedClientDomainSlugFeedbackIndexRoute:
      AuthenticatedClientDomainSlugFeedbackIndexRoute,
    AuthenticatedClientDomainSlugJournalIndexRoute:
      AuthenticatedClientDomainSlugJournalIndexRoute,
    AuthenticatedClientDomainSlugLogsIndexRoute:
      AuthenticatedClientDomainSlugLogsIndexRoute,
    AuthenticatedClientDomainSlugPlansIndexRoute:
      AuthenticatedClientDomainSlugPlansIndexRoute,
    AuthenticatedClientDomainSlugTicketsIndexRoute:
      AuthenticatedClientDomainSlugTicketsIndexRoute,
  }

const AuthenticatedClientDomainSlugRouteWithChildren =
  AuthenticatedClientDomainSlugRoute._addFileChildren(
    AuthenticatedClientDomainSlugRouteChildren,
  )

interface AuthenticatedClientDomainRouteChildren {
  AuthenticatedClientDomainSlugRoute: typeof AuthenticatedClientDomainSlugRouteWithChildren
  AuthenticatedClientDomainIndexRoute: typeof AuthenticatedClientDomainIndexRoute
  AuthenticatedClientDomainSlugInterviewTicketRoute: typeof AuthenticatedClientDomainSlugInterviewTicketRoute
}

const AuthenticatedClientDomainRouteChildren: AuthenticatedClientDomainRouteChildren =
  {
    AuthenticatedClientDomainSlugRoute:
      AuthenticatedClientDomainSlugRouteWithChildren,
    AuthenticatedClientDomainIndexRoute: AuthenticatedClientDomainIndexRoute,
    AuthenticatedClientDomainSlugInterviewTicketRoute:
      AuthenticatedClientDomainSlugInterviewTicketRoute,
  }

const AuthenticatedClientDomainRouteWithChildren =
  AuthenticatedClientDomainRoute._addFileChildren(
    AuthenticatedClientDomainRouteChildren,
  )

interface AuthenticatedClientRouteChildren {
  AuthenticatedClientDomainRoute: typeof AuthenticatedClientDomainRouteWithChildren
  AuthenticatedClientIndexRoute: typeof AuthenticatedClientIndexRoute
}

const AuthenticatedClientRouteChildren: AuthenticatedClientRouteChildren = {
  AuthenticatedClientDomainRoute: AuthenticatedClientDomainRouteWithChildren,
  AuthenticatedClientIndexRoute: AuthenticatedClientIndexRoute,
}

const AuthenticatedClientRouteWithChildren =
  AuthenticatedClientRoute._addFileChildren(AuthenticatedClientRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedClientRoute: typeof AuthenticatedClientRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedChecksRunRoute: typeof AuthenticatedChecksRunRoute
  AuthenticatedKnowledgeNoteRoute: typeof AuthenticatedKnowledgeNoteRoute
  AuthenticatedChecksIndexRoute: typeof AuthenticatedChecksIndexRoute
  AuthenticatedKnowledgeIndexRoute: typeof AuthenticatedKnowledgeIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedClientRoute: AuthenticatedClientRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedChecksRunRoute: AuthenticatedChecksRunRoute,
  AuthenticatedKnowledgeNoteRoute: AuthenticatedKnowledgeNoteRoute,
  AuthenticatedChecksIndexRoute: AuthenticatedChecksIndexRoute,
  AuthenticatedKnowledgeIndexRoute: AuthenticatedKnowledgeIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  ShareTokenRoute: ShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
